import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isFeaturePresent } from '../../util/CommonUtils';

class LeftNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listItems: props.listItems,
    };
  }

  componentDidMount() {
    this.onMount();
  }

  onMount = () => {
    const { listItems } = this.state;
    const modifiedList = listItems.map(item => {
      if (item.mainMenu === this.props.mainMenu) {
        item.checked = true;
      } else {
        item.checked = false;
      }
      return item;
    });
    this.setState({ listItems: modifiedList });
  }

  changeSelection = selectedItem => {
    const { listItems } = this.state;
    const modifiedList = listItems.map(item => {
      if (item.mainMenu === selectedItem) {
        item.checked = !item.checked;
      }
      return item;
    });
    this.setState({ listItems: modifiedList });
  };

  render() {
    const { listItems } = this.state;
    const { modulePermissions, handleMenuSelection, selectedMenu } = this.props;
    return (<div className="column large-2 medium-2 sidenav-container">
      <div className="preference-label">
        Preferences
      </div>
      <div className="custom-accordion">
        {listItems.map(mainMenuItems => {
          return (<div key={mainMenuItems.key} className="custom-accordion-item">
            <div className="custom-accordion-item-header">
              <input
                id={mainMenuItems.id}
                type="checkbox"
                checked={mainMenuItems.checked}
                onChange={() => this.changeSelection(mainMenuItems.mainMenu)}
              />
              <label
                className={mainMenuItems.class}
                htmlFor={mainMenuItems.id}
                title={mainMenuItems.mainMenu}
              >
                {mainMenuItems.mainMenu}
              </label>
            </div>
            <div
              className={`custom-accordion-item-content ${mainMenuItems.checked ? 'display-block' : 'display-hidden'}`}
            >
              {mainMenuItems.subMenu.map(subMenuItem => {
                return ((isFeaturePresent(
                  subMenuItem.featureId, modulePermissions) ||
                  subMenuItem.visible) &&
                  <button
                    type = "button"
                    key={subMenuItem.key}
                    className={`custom-accordion-item-content-btn ${subMenuItem.menuName === selectedMenu ? 
                      'custom-accordion-item-content-btn-active' : ''}`}
                    tabIndex={0}
                    onClick={() => handleMenuSelection(subMenuItem.menuName)}
                    disabled={!subMenuItem.enabled}
                  >{subMenuItem.title}</button>
                  );
              })}
            </div>
          </div>);
        })}
      </div>
    </div>
  );
  }
}

LeftNavigation.propTypes = {
  modulePermissions: PropTypes.instanceOf(Array),
  listItems: PropTypes.arrayOf(PropTypes.object),
  handleMenuSelection: PropTypes.func,
  selectedMenu: PropTypes.string,
  mainMenu: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    modulePermissions: state.userDetail.permissions,
  };
}

export default connect(mapStateToProps, null)(LeftNavigation);
